import React, { useEffect, useRef } from 'react';

const MapComponent = ({ latitude, longitude, locationName, height = '400px' }) => {
  const mapRef = useRef(null);

  useEffect(() => {
    // Initialize map using Leaflet (free alternative to Google Maps)
    if (mapRef.current && window.L) {
      const map = window.L.map(mapRef.current).setView([latitude, longitude], 13);

      window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors'
      }).addTo(map);

      window.L.marker([latitude, longitude])
        .addTo(map)
        .bindPopup(locationName || 'Location')
        .openPopup();

      return () => {
        map.remove();
      };
    }
  }, [latitude, longitude, locationName]);

  return (
    <div>
      <div ref={mapRef} style={{ height, width: '100%' }} className="rounded-xl overflow-hidden"></div>
      <p className="text-sm text-gray-500 mt-2">
        {locationName} ({latitude.toFixed(6)}, {longitude.toFixed(6)})
      </p>
    </div>
  );
};

export default MapComponent;